jQuery(function ($) {
  "use strict";

  var init = [
    function () {
      if ($('.scroll-to-top').length) {
        let mybutton = document.getElementById("btn-back-to-top");

        // When the user scrolls down 150px from the top of the document, show the button
        window.onscroll = function () {
          scrollFunction();
        };

        function scrollFunction() {
          if (
            document.body.scrollTop > 150 ||
            document.documentElement.scrollTop > 150
          ) {
            mybutton.style.display = "block";
          } else {
            mybutton.style.display = "none";
          }
        }
        // When the user clicks on the button, scroll to the top of the document
        mybutton.addEventListener("click", backToTop);

        function backToTop() {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      } else {}
    },
    function () {
      if ($('.main-navigation .main-navigation__search .site-search').length) {
        $(".main-navigation .main-navigation__search .site-search").click(function(){
          $(".main-navigation .main-navigation__search .search-form").toggle();
        });
      }
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-column',
          animateClass: 'fadeIn',
          offset:       0,
          mobile:       false,
          live:         true,
        }
      ).init();
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-cover__inner-container',
          animateClass: 'fadeInUp',
          offset:       0,
          mobile:       false,
          live:         true,
        },
      ).init();
    },
    function () {
      $('s').addClass('strikethrough');
    },
    function () {
      new WOW(
        {
          boxClass:     'strikethrough',
          animateClass: 'increase',
          offset:       50,
          mobile:       true,
          live:         true,
        }
      ).init();
    },
    function () {
      $(document).ready(function() {
        var headerHeight = $('.site-header').outerHeight();
        var body = $('body');
        var sticky = $('.site-header');
        let menu = $('#menu');
        let nav = $('.main-navigation__nav');

        // Function to handle sticky header
        function handleStickyHeader() {
          var scroll = $(window).scrollTop();

          if (scroll >= headerHeight + 10) {
            sticky.addClass('site-header--sticky');
            body.css('padding-top', headerHeight);
          } else {
            sticky.removeClass('site-header--sticky');
            body.css('padding-top', 0);
          }
        }

        // Function to add or remove buttons based on viewport size
        function handleResponsiveMenu() {
          $('.site-header .menu .menu-item.menu-item-has-children').each(function() {
            if (!$(this).find('.menu-item-dropdown-toggle').length) {
              $(this).append('<button class="menu-item-dropdown-toggle"></button>');
            }
          });
        }

        function positionSubMenu() {
          var subMenus = document.querySelectorAll('.site-header .menu .menu-item.menu-item-has-children .sub-menu');

          subMenus.forEach(function(subMenu) {
            // Temporarily set the sub-menu to be visible
            subMenu.style.display = 'block';

            var rect = subMenu.getBoundingClientRect();

            // Check if there's enough space on the right
            if (rect.right > window.innerWidth) {
              subMenu.classList.add('sub-menu--right');
            } else {
              subMenu.classList.remove('sub-menu--right');
            }

            // Hide the sub-menu again
            subMenu.style.display = 'none';
          });
        }

        // Initial call to handleStickyHeader to set the initial state
        handleStickyHeader();
        handleResponsiveMenu();
        positionSubMenu();

        // Bind scroll event to handleStickyHeader
        $(window).scroll(handleStickyHeader);

        // Bind resize event to handleResponsiveMenu
        $(window).resize(handleResponsiveMenu);

        // Bind resize event to positionSubMenu
        $(window).resize(positionSubMenu);

        // Set initial top position for mobile navigation
        $('.site-header .main-navigation .main-navigation__nav').css('top', headerHeight);

        menu.on('click', function(e) {
          $(this).toggleClass('is-open');
          nav.toggleClass('is-open');
        });

        // Toggle sub-menus when the dropdown button is clicked
        $('.site-header .menu .menu-item.menu-item-has-children .menu-item-dropdown-toggle').on('click', function(e) {
          e.preventDefault();
          var subMenu = $(this).siblings('.sub-menu');
          $(this).toggleClass('menu-item-dropdown-toggle--active');
          subMenu.slideToggle();
        });
      });
    },
  ];

  $.each(init, function (index, initFunction) {
    initFunction();
  });
});